module.exports = __webpack_public_path__ + "static/media/hafiðunknown.2555f2e7.svg";